var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification is-danger is-light py-2 is-flex is-align-items-center"},[_c('i',{staticClass:"mdi mdi-alert-octagram mdi-30px pr-1"}),_c('span',{staticClass:"has-text-weight-bold"},[_vm._v("Please go to PartsCheck to make changes to the order items")])])
}]

export { render, staticRenderFns }